var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.BUSINESS_REPORT_SALE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "auto-fetch": false,
          "is-list": "",
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "is-pagination": false,
          "right-toolbar-hide": true,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessReportSaleCensus.orderTime"),
                        },
                      },
                      [
                        _c("BjDateRangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportSaleCensus.orderTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessReportSaleCensus.dateType"),
                          prop: "dateType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            clearable: false,
                            "option-list":
                              _vm.REPORT_SALE_STATISTICS_TIME_LIST2,
                            placeholder: _vm.$t(
                              "BusinessReportSaleCensus.dateType"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.dateType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "dateType", $$v)
                            },
                            expression: "queryParams.dateType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("customerNameText"),
                              prop: "sapOrderNo",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                "option-list": _vm.customerList,
                                placeholder: _vm.$t("customerNameText"),
                              },
                              model: {
                                value: _vm.queryParams.cusId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "cusId", $$v)
                                },
                                expression: "queryParams.cusId",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    prop: "type",
                    label: _vm.$t("BusinessReportSaleCensus.channel"),
                    width: "120px",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [_vm._v(_vm._s(_vm.$t("dateText")))]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.queryParams.type == 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.SCHL_CHANNEL_TYPE.bjGet(scope.row.type)
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v(_vm._s(scope.row.type))]),
                        ]
                      },
                    },
                  ]),
                }),
                !_vm.$store.getters.cusId
                  ? _c("el-table-column", {
                      attrs: {
                        prop: "aaa",
                        label: _vm.$t("customerNameText"),
                        width: "120px",
                        align: "center",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "header",
                            fn: function () {
                              return [
                                _vm._v(_vm._s(_vm.$t("customerNameText"))),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.customerList.bjGet(scope.row.cusId)
                                    )
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3707742992
                      ),
                    })
                  : _vm._e(),
                _c(
                  "vxe-colgroup",
                  {
                    attrs: {
                      title: _vm.$t("BusinessReportSaleCensus.totalSales"),
                      align: "center",
                      fixed: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderCount",
                        label: _vm.$t("BusinessReportSaleCensus.orderCount"),
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemCount",
                        label: _vm.$t("BusinessReportSaleCensus.itemCount"),
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseOrderCount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.reverseOrderCount"
                        ),
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseItemCount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.reverseItemCount"
                        ),
                        align: "center",
                        sortable: "",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }